import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuItem from '@mui/material/MenuItem';
import { css } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
export const autocompleteComponentOverrides = {
    MuiAutocomplete: {
        defaultProps: {
            ChipProps: undefined,
            autoHighlight: true,
            color: undefined,
            multiple: false, // temporarily disable
            popupIcon: _jsx(KeyboardArrowDownIcon, {}),
            renderOption: (optionProps, option, state) => {
                const matches = match(String(option.label), state.inputValue, {
                    insideWords: true
                });
                const parts = parse(String(option.label), matches);
                return (_createElement(MenuItem, { ...optionProps, key: option.label },
                    _jsx(Typography, { component: 'span', display: 'inline-block', flexGrow: 1, lineHeight: 'inherit', noWrap: true, variant: 'body2', children: parts.map((part, index) => part.highlight ?
                            _jsx("strong", { children: part.text }, index) :
                            _jsx("span", { children: part.text }, index)) })));
            }
        },
        styleOverrides: {
            root: css `
                padding: unset;
            `,
            input: css `
                padding: unset !important;
            `,
            endAdornment: ({ theme }) => css `
                display: flex;
                right: ${theme.tokens.FuelSpacing2};

                .MuiIconButton-root {
                    margin: unset;
                    height: ${theme.tokens.FuelSpacing6};
                    width: ${theme.tokens.FuelSpacing6};
                }
            `,
            option: ({ theme }) => css `
                cursor: pointer;
                position: relative;
                color: ${theme.tokens.FuelColorTextPrimary};
                font-family: ${theme.tokens.FuelFontFamilyBase};
                font-size: ${theme.tokens.FuelFontSizeSm};
                line-height: ${theme.tokens.FuelLineHeightBase};
                text-align: start;
                padding-inline: ${theme.tokens.FuelSpacing4};
                padding-block: ${theme.tokens.FuelSpacing2};

                &[aria-selected="true"] {
                    color: ${theme.tokens.FuelColorBrandPrimary};
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultSelected};

                    &::before {
                        content: "";
                        position: absolute;
                        width: 3px;
                        height: 100%;
                        left: 0;
                        top: 0;
                        background-color: ${theme.tokens.FuelColorBackgroundActionDefaultSelectedBar};
                    }
                }

                &:hover, &:focus-visible, &.Mui-focusVisible {
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultHovered};
                }

                &:active {
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultPressed};
                }

                &:focus-visible, &.Mui-focusVisible {
                    box-shadow: var(--menu-item-outline-focus);
                }
            `,
            popper: ({ theme }) => css `
                & .MuiAutocomplete-option.MuiAutocomplete-option {
                    padding-bottom: ${theme.tokens.FuelSpacing2};
                    padding-top: ${theme.tokens.FuelSpacing2};
                }
            `
        }
    }
};
